import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const archiveSkillMap = api(async function archiveSkillMap({ id }) {
    return mutate(
        gql`
            mutation ArchiveSkillMap($id: String!) {
                archiveSkillMap(id: $id)
            }
        `,
        { id },
        { returns: "archiveSkillMap" }
    )
})
